import { LoginMethod, TnTracking } from "@telenornorgeinternal/telenor-norway-tracking";
import type { Product } from "@telenornorgeinternal/telenor-norway-tracking";

type ProductOrProductPromise = Product | Promise<Product>;

interface AnalyticsComposable extends TnTracking {
	addProduct(product: ProductOrProductPromise): void;

	resetProducts(): void;

	hasProducts(): boolean;

	getProducts(): ProductOrProductPromise[];

	isDisabled: boolean;
}

const tnAnalytics = ref(null);

const products = ref<ProductOrProductPromise[]>([]);

function addProduct(product: ProductOrProductPromise) {
	products.value.push(product);
}

function resetProducts() {
	products.value = [];
}

function hasProducts() {
	return products.value.length > 0;
}

function getProducts() {
	return products.value;
}

export function useAnalytics(): AnalyticsComposable | null {
	const { tealium_profile, tealium_env = "qa" } = useRuntimeConfig().public;
	const userStore = useUserStore();
	const contactDetailsStore = useContactDetailsStore();
	const pageStore = usePageStore();
	const disableTrackingTemplates = ["tweBoxWebApp"];
	const isDisabled =
		useRuntimeConfig().public.disableTracking || disableTrackingTemplates.includes(pageStore.page?.template?.ref);

	const init = () => {
		tnAnalytics.value = new TnTracking({
			tealium: {
				profile: tealium_profile,
				env: tealium_env,
				singlePageApp: true,
			},
			user: (async () => {
				await userStore.getOrSetUser();
				if (userStore.customer) {
					await contactDetailsStore.fetchContactDetails();
					return {
						kurt: userStore.customer.kurtId,
						birthDate: userStore.customer.birthDate,
						email: contactDetailsStore.emailAddress,
						phone: contactDetailsStore.phoneNumber,
						loginMethod: LoginMethod.fromAcr(userStore.customer.acr),
					};
				} else {
					return null;
				}
			})(),
		});
	};

	if (!tnAnalytics.value) {
		if (import.meta.client && !isDisabled) init();
		else tnAnalytics.value = {};
		tnAnalytics.value.addProduct = addProduct;
		tnAnalytics.value.resetProducts = resetProducts;
		tnAnalytics.value.hasProducts = hasProducts;
		tnAnalytics.value.getProducts = getProducts;
	}

	tnAnalytics.value.isDisabled = isDisabled;
	return tnAnalytics.value; /*{
		...tnAnalytics.value,
		addProduct,
		resetProducts,
		products
	};*/
}
